import { render } from "./MainProducts.vue?vue&type=template&id=724e83e2&scoped=true"
import script from "./MainProducts.vue?vue&type=script&lang=js"
export * from "./MainProducts.vue?vue&type=script&lang=js"

import "./MainProducts.vue?vue&type=style&index=0&id=724e83e2&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724e83e2"]])

export default __exports__